import DealerReviewComparision from "../../../Components/Table/DealerReviewComparision";

const Retail_Comparision = () => {
  return (
    <div className="bg-white shadow-lg text-xs rounded-lg w-full relative h-full">
      <h2 className="text-lg font-bold text-gray-800  p-2 pb-0">
        Retail Comparision
      </h2>
      <DealerReviewComparision
        endpoint="dealer-review/retail_comparision"
        expansionEndpoint="dealer-review/retail_lob_wise_comparision"
      />
    </div>
  );
};

export default Retail_Comparision;
